"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _watchers = require("../../../astercore/profile/masterAPI/redux/watchers");
var _sagas = require("../../../astercore/onboarding/redux/sagas");
var _sagas2 = require("../../../astercore/mypayments/redux/sagas");
var _sagas3 = require("../../../astercore/auth/login/redux/sagas");
var _watchers2 = require("../../profile/profile/redux/watchers");
var _sagas4 = require("../../../astercore/auth/otp/redux/sagas");
var _sagas5 = require("../../../astercore/appConfig/redux/sagas");
var _sagas6 = require("../../loyalty/redux/sagas");
var _sagas7 = require("../../settings/redux/sagas");
var _sagas8 = require("../../globalSearch/redux/sagas");
var _sagas9 = require("../../cms/redux/sagas");
var _sagas10 = require("../../nps/redux/sagas");
var _sagas11 = require("../../../astercore/healthProfile/redux/sagas");
var _sagas12 = require("../../../astercore/auth/uaepass/redux/sagas");
var _sagas13 = require("../../identityService/redux/sagas");
var _sagas14 = require("../../../astercore/authService/redux/sagas");
// Imports: Redux Sagas
// Redux Saga: Root Saga
var _default = exports.default = [(0, _watchers.masterApiWatchers)(), (0, _sagas.onboadingWatchers)(), (0, _sagas3.loginWatchers)(), (0, _watchers2.profileApiWatchers)(), (0, _sagas4.otpWatchers)(), (0, _sagas5.appConfigWatchers)(), (0, _sagas6.loyaltyWatechers)(), (0, _sagas2.paymentWatchers)(), (0, _sagas7.settingsWatchers)(), (0, _sagas8.globalSearchWatchers)(), (0, _sagas9.CMSWatcher)(), (0, _sagas10.NPSWatcher)(), (0, _sagas11.hpOnboadingWatchers)(), (0, _sagas13.commonAPIWatchers)(), (0, _sagas12.uaePassWatchers)(), (0, _sagas14.authServiceWatchers)()];